import SignUp from "./signup";
const SignPG = () => {
    return (
              <div className="">
                <header className="App-header">
                  <a>
                  <SignUp></SignUp>
                  </a>
          
                </header>
              </div>
            );
          }
export default SignPG;
          